import layout from './ViewExtensionView.html?raw';
import View from '@/Views/View';
import ComponentManager from '@/Management/ComponentManager';

export default class ViewExtensionView extends View {
    private view: JQuery<HTMLElement>;

    public constructor(private viewModel: any, private element?: JQuery<HTMLElement>) {
        super();
    }

    public getView(): JQuery<HTMLElement> {
        if (this.view != null) {
            return this.view;
        }

        this.view = this.applyBindings(this.element, this.viewModel, layout);

        return this.view;
    }
}

ComponentManager.setView('ViewExtensionView', ViewExtensionView, 'RADPresentation.HTMLClient.DefaultViewExtensions');